import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Modal, { bemClasses } from 'general/js/modal';

class ReactModal extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
        this.closeModal = true;
    }

    componentDidMount() {
        document.body.appendChild(this.el);
        const options = Object.assign(
            {
                bemList: [bemClasses.MOBILE_FIXED, bemClasses.WIDE],
                delegateControl: true,
                onCloseCb: this.props.onCloseCb,
                previousOpenedModal: null
            },
            this.props.options
        );

        this.modal = new Modal(this.el, options);

        if (this.props.isOpen) {
            this.modal.open();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            if (this.props.isOpen) {
                this.modal.open(this.props.options);
            } else {
                const { closeModal } = this.props;
                this.closeModal = closeModal !== undefined ? closeModal : this.closeModal;
                if (this.closeModal) {
                    this.modal.close();
                }
            }
        }
    }

    componentWillUnmount() {
        this.modal.destroy();
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.el,
        );
    }
}

ReactModal.propTypes = {
    options: PropTypes.object,
    isOpen: PropTypes.bool,
    onCloseCb: PropTypes.func,
};

export default ReactModal;
